<template>
  <div>
    <div class="match-pair-option">
      <div class="index-number">
        {{ index + 1 }}
      </div>
      <div class="input-and-image">
        <div class="pair-group prompt-group">
          <AhaInput
            class="match-pair-text-input prompt-input"
            :rounded="false"
            :max-length="150"
            :placeholder="$i18nPresenter.t('Prompt')"
            :highlight-on-hover="false"
            v-model="title"
            @input="handleTitleChanged"
          />
          <MatchPairImageButton
            :matchPairImageType="'PromptImage'"
            :slideOption="slideOption"
            :slideActive="slideActive"
            :presentation="presentation"
            :index="index"
          />
        </div>
        <div class="pair-group answer-group">
          <AhaInput
            class="match-pair-text-input answer-input"
            :rounded="false"
            :max-length="150"
            :placeholder="$i18nPresenter.t('Answer')"
            :highlight-on-hover="false"
            v-model="pairTitle"
            @input="handleTitleChanged"
          />
          <MatchPairImageButton
            :matchPairImageType="'AnswerImage'"
            :slideOption="slideOption"
            :slideActive="slideActive"
            :presentation="presentation"
            :index="index"
          />
        </div>
      </div>
      <div
        class="delete-button"
        :class="{
          'cursor-pointer': isDeletable,
          'cursor-not-allowed': !isDeletable,
        }"
        @click="isDeletable && handleDeleteSlideOption(slideOption.id)"
      >
        <i class="far fa-trash-alt" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import MatchPairImageButton from './MatchPairImageButton.vue'
import EventBus from '@/eventBus'

export default {
  components: {
    MatchPairImageButton,
  },
  props: {
    slideOption: {
      type: Object,
      required: true,
    },
    slideActive: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: true,
    },
    handleDeleteSlideOption: {
      type: Function,
      required: true,
    },
    handleSlideOptionChanged: {
      type: Function,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      pairTitle: '',
    }
  },
  computed: {
    ...mapGetters('history', ['canUseUndoRedoV2']),
  },
  mounted() {
    this.handleSlideOptionChangedDebounce = _.debounce(this.handleSlideOptionChanged, 600)
    this.title = this.slideOption.title
    this.pairTitle = this.slideOption.pairTitle
    // Listen to event to update field match pair
    if (this.canUseUndoRedoV2) {
      EventBus.$on('update-field-match-pair', () => {
        this.title = this.slideOption.title
        this.pairTitle = this.slideOption.pairTitle
      })
    }
  },
  destroyed() {
    if (this.canUseUndoRedoV2) {
      EventBus.$off('update-field-match-pair')
    }
  },
  methods: {
    handleTitleChanged() {
      const payload = {
        title: this.title,
        pairTitle: this.pairTitle,
      }

      this.handleSlideOptionChangedDebounce(this.slideOption.id, payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.match-pair-option {
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 12px;
  .index-number {
    @apply border-secondary-20 bg-secondary-10 text-secondary-50 ;
    @apply rounded-l border-l border-t border-b w-6;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input-and-image {
    margin-right: 8px;
    flex-grow: 1;
  }

  .pair-group {
    display: flex;
    flex-direction: row;
  }

  .delete-button {
    @apply border border-secondary-20 bg-secondary-10 text-secondary-50 ;
    @apply rounded-sm w-8;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.match-pair-text-input {
  flex-grow: 1;
  & ::v-deep .aha-input {
    height: 100%;
    padding-right: 3.75rem;
  }

  &.prompt-input {
    & ::v-deep .aha-input {
      border-bottom: 0;
    }
  }
}

</style>
